import styled from 'styled-components';

/** Anchors the suggestions under the field. */
export const FilterAnchor = styled.div`
  position: relative;
  margin-top: 8px;
`;

/**
 * The matching locations, hung under the field rather than pushed into the
 * flow: they are a moment's choice, and moving the people list down to make
 * room for them would shift the rows somebody is about to click.
 */
export const Suggestions = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 3;
  max-height: 264px;
  overflow-y: auto;
  padding: 6px;
  background: ${({ theme }) => theme.white};
  border: ${({ theme }) => theme.borders.border1};
  border-radius: 16px;
  box-shadow: ${({ theme }) => theme.shadows.shadow1};
`;

export const Suggestion = styled.button`
  display: block;
  width: 100%;
  padding: 8px 10px;
  border: none;
  border-radius: 10px;
  background: transparent;
  text-align: left;
  font-family: inherit;
  cursor: pointer;
  transition: ${({ theme }) => theme.transitions.ease200ms};

  :hover {
    background: ${({ theme }) => theme.gray};
  }
`;

/**
 * The chosen location, in place of the field: a pill that says what the list
 * is narrowed to and clears with one click. The field's own height, so
 * picking one does not move anything below it.
 */
export const LocationChip = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  height: 42px;
  padding: 0 6px 0 14px;
  border-radius: 24px;
  background: ${({ theme }) => theme.transparentRed};
  color: ${({ theme }) => theme.darkGray};

  svg {
    flex: none;
  }
`;

/** Takes the slack so a long name ellipses instead of pushing the clear out. */
export const ChipName = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ClearButton = styled.button`
  flex: none;
  width: 30px;
  height: 30px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: ${({ theme }) => theme.white};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
